import "./_contentOnglet.scss";

import cx from "classnames";
import {ReactElement} from "react";
import {useNavigate} from "react-router-dom";

import iconArrow from "@/assets/iconArrow.svg";

import Button from "../Button/Button";
import {Fleche} from "../Fleche/Fleche";

function ContentOnglet({
  title,
  link,
  children,
}: {
  title: string;
  link?: string;
  children?: React.ReactNode;
}): ReactElement {
  const navigate = useNavigate();
  const isOpen = children ? true : false;
  const handleGoBack = (): void => {
    navigate(-1); // `-1` signifie revenir en arrière d'une page dans l'historique
  };
  return (
    <div
      className={cx("contentOnglet", isOpen ? "" : "contentOnglet-close")}
      onClick={() => {
        if (link && !children) {
          navigate(link);
        }
      }}>
      <div className="contentOnglet-header">
        <Fleche variant="orange" />
        {isOpen ? (
          <Button
            label="Retour"
            variant={"secondary"}
            icon={iconArrow}
            className="returnButton"
            onClick={() => handleGoBack()}
          />
        ) : null}
        <div id="pageTitle">
          <p className="contentOnglet-title">{title}</p>
        </div>
      </div>

      <div className="contentOnglet-content">{children}</div>
    </div>
  );
}

export default ContentOnglet;
